import {Editor, type EditorInterface} from '../interfaces/editor'
import {Text} from '../interfaces/text'

export const hasInlines: EditorInterface['hasInlines'] = (editor, element) => {
  return element.children.some(
    (n) => Text.isText(n, editor.schema) || Editor.isInline(editor, n),
  )
}
